import { render } from "./TemporaryWorkCreate.vue?vue&type=template&id=ef95b512&scoped=true"
import script from "./TemporaryWorkCreate.vue?vue&type=script&lang=js"
export * from "./TemporaryWorkCreate.vue?vue&type=script&lang=js"

import "./TemporaryWorkCreate.vue?vue&type=style&index=0&id=ef95b512&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef95b512"]])

export default __exports__